import React, {Component} from 'react';
import PropTypes from 'prop-types';
import size from 'lodash/size';
import {Button, ButtonToolbar} from 'react-bootstrap';
import classNames from 'classnames';
import Confirmation from './Confirmation';
import Mousetrap from 'mousetrap';
import {isMac} from '../isMac';
import ReactTooltip from 'react-tooltip';

export class SelectionToolbar extends Component {
    static propTypes = {
        urlPrefix: PropTypes.string,
        selectedImages: PropTypes.array.isRequired,
        onResetSelection: PropTypes.func.isRequired,
        onDeleteSelection: PropTypes.func,
        onDownloadSelection: PropTypes.func,
        onPrintSelection: PropTypes.func,
        hideEditButtons: PropTypes.bool,
        history: PropTypes.object,
    };

    static defaultProps = {
        urlPrefix: '',
    };

    componentDidMount() {
        Mousetrap.bind('mod+del', (e) => {
            if (this.deleteConfirmation) {
                this.deleteConfirmation.openModal(e);
            }
        });
        Mousetrap.bind('e', (e) => {
            e.preventDefault();
            this.handleOpen(true);
        });
        Mousetrap.bind('v', (e) => {
            e.preventDefault();
            this.handleOpen(false);
        });
        Mousetrap.bind('mod+s', (e) => {
            e.preventDefault();
            if (this.downloadConfirmation) {
                this.downloadConfirmation.openModal(e);
            }
        });
        Mousetrap.bind('mod+p', (e) => {
            e.preventDefault();
            if (this.printConfirmation) {
                this.printConfirmation.openModal(e);
            }
        });
        if (this.toolbar) {
            this.toolbar.focus();
        }
    }

    componentWillUnmount() {
        // noinspection JSUnresolvedFunction
        Mousetrap.unbind(['e', 'v', 'mod+s', 'mod+p', 'mod+del']);
    }

    handleReset = () => {
        this.props.onResetSelection();
    };

    handlePrint = () => {
        this.props.onPrintSelection();
    };

    handleDownload = () => {
        this.props.onDownloadSelection();
    };

    handleOpen = () => {
        const {history, selectedImages, urlPrefix} = this.props;
        const count = size(selectedImages);
        if (count === 0) {
            return;
        }
        history.push(`${urlPrefix}/image/${selectedImages[0]}`);
    };

    handleDelete = () => {
        this.props.onDeleteSelection();
    };

    render() {
        const {selectedImages, hideEditButtons} = this.props;

        const count = size(selectedImages);
        const selectionMode = count > 0;

        return (<div className={classNames('selection-toolbar', {selectionMode})} ref={c => this.toolbar = c} tabIndex={0}>
            <Button bsStyle="link" onClick={this.handleReset} data-tip data-for="resetTooltip">{'×'}</Button>
            <span className="selection-count">{`${count} selected`}</span>
            <ReactTooltip id="resetTooltip" place="right" delayShow={400} className="dark-tool-tip" type="dark">
                <div>{'Clear selection'}</div>
                <kbd>{'esc'}</kbd>
            </ReactTooltip>
            <ReactTooltip id="printTooltip" place="bottom" delayShow={400} className="dark-tool-tip" type="dark">
                <div>{'Print selected images'}</div>
                <kbd>{isMac ? 'cmd-p' : 'ctrl-p'}</kbd>
            </ReactTooltip>
            <ReactTooltip id="downloadTooltip" place="bottom" delayShow={400} className="dark-tool-tip" type="dark">
                <div>{'Download selected images'}</div>
                <kbd>{isMac ? 'cmd-s' : 'ctrl-s'}</kbd>
            </ReactTooltip>
            <ReactTooltip id="viewTooltip" place="bottom" delayShow={400} className="dark-tool-tip" type="dark">
                <div>{'Open the viewer for selected images'}</div>
                <kbd>{'v'}</kbd>
            </ReactTooltip>
            <ReactTooltip id="editTooltip" place="bottom" delayShow={400} className="dark-tool-tip" type="dark">
                <div>{'Open the editor for selected images'}</div>
                <kbd>{'e'}</kbd>
            </ReactTooltip>
            <ReactTooltip id="deleteTooltip" place="left" delayShow={400} className="dark-tool-tip" type="dark">
                <div>{'Delete selected images'}</div>
                <kbd>{isMac ? 'cmd-delete' : 'ctrl-delete'}</kbd>
            </ReactTooltip>
            <ButtonToolbar className="pull-right">
                <Confirmation
                    name="printConfirmation"
                    bsStyle="link"
                    onConfirm={this.handlePrint}
                    componentLabel={<i className="fa fa-print"/>}
                    data-tip data-for="printTooltip"
                    ref={c => this.printConfirmation = c}
                >
                    {`Print ${count} ${count > 1 ? 'images' : 'image'}?`}
                </Confirmation>
                <Confirmation
                    name="downloadConfirmation"
                    bsStyle="link"
                    onConfirm={this.handleDownload}
                    componentLabel={<i className="fa fa-download"/>}
                    data-tip data-for="downloadTooltip"
                    ref={c => this.downloadConfirmation = c}
                >
                    {`Download ${count} ${count > 1 ? 'images' : 'image'}?`}
                </Confirmation>
                <Button bsStyle="link" onClick={this.handleOpen} data-tip data-for="viewTooltip">
                    <i className="fa fa-search-plus"/>
                </Button>
                {!hideEditButtons &&
                <Confirmation
                    name="deleteConformationModal"
                    bsStyle="link"
                    onConfirm={this.handleDelete}
                    componentLabel={<i className="fa fa-trash"/>}
                    data-tip data-for="deleteTooltip"
                    ref={c => this.deleteConfirmation = c}
                >
                    {`Delete ${count} ${count > 1 ? 'images' : 'image'}?`}
                </Confirmation>}
            </ButtonToolbar>
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/SelectionToolbar.js